import { SourceType } from '@aloft/toolkit-shared';
import { theme } from '@aloft/toolkit-sui';

export const FEATURE_GRID_DATA_SOURCES: SourceType[] = ['inspectify_inspection','abode_mls', 'abode_public_record'];
export const ADJUSTMENTS_GRID_DATA_SOURCES: SourceType[] = ['regression', 'sensitivity'];

export const PROPERTY_HEADER_IMAGE_HEIGHT = '110px';
export const PROPERTY_HEADER_IMAGE_WIDTH = '99px';
export const PROPERTY_HEADER_COLOR_BAND_HEIGHT = '5px';

export const LABEL_COLUMN_WIDTH = '250px';
export const PROPERTY_GRID_COLUMN_WIDTH = '375px';
export const AIV_ARV_PROPERTY_GRID_COLUMN_WIDTH = '525px';
export const PROPERTY_GRID_ROW_HEIGHT = '32px';

/** Single-pixel solid border in the grid stroke colour, used on right, bottom, and left sides of each column. */
export const GRID_BORDER = `1px solid ${theme.colors.strokeDefault}`;
